document.addEventListener("DOMContentLoaded", () => {
  const media = window.matchMedia("(min-width: 960px)")
  const filterPanel = document.querySelector("[data-filter-panel]")

  const syncFilterPanel = (event) => {
    if (filterPanel) filterPanel.open = event.matches
  }

  const searchForm = document.querySelector(".search-form")
  let searchFormResizeFrame

  const updateSearchFormHeight = () => {
    if (!searchForm || (!media.matches && !filterPanel?.open)) return

    const top = Math.max(searchForm.getBoundingClientRect().top, media.matches ? 20 : 12)
    const bottomGap = media.matches ? 20 : 12
    const availableHeight = Math.max(180, window.innerHeight - top - bottomGap)
    searchForm.style.setProperty("--search-form-available-height", `${availableHeight}px`)
  }

  const scheduleSearchFormResize = () => {
    window.cancelAnimationFrame(searchFormResizeFrame)
    searchFormResizeFrame = window.requestAnimationFrame(updateSearchFormHeight)
  }

  syncFilterPanel(media)
  scheduleSearchFormResize()
  media.addEventListener("change", (event) => {
    syncFilterPanel(event)
    scheduleSearchFormResize()
  })
  filterPanel?.addEventListener("toggle", scheduleSearchFormResize)
  window.addEventListener("resize", scheduleSearchFormResize)
  window.addEventListener("scroll", scheduleSearchFormResize, { passive: true })

  const manufacturingCategory = document.querySelector("[data-manufacturing-category]")
  const manufacturingToggle = document.querySelector("[data-manufacturing-toggle]")
  const manufacturingDetails = document.querySelector("[data-manufacturing-details]")
  const manufacturingDetailInputs = Array.from(document.querySelectorAll("[data-manufacturing-detail]"))

  const setManufacturingDetailsOpen = (open) => {
    if (!manufacturingDetails || !manufacturingToggle) return

    manufacturingDetails.hidden = !open
    manufacturingToggle.setAttribute("aria-expanded", open.toString())
  }

  const hasSelectedManufacturingDetail = () => manufacturingDetailInputs.some((input) => input.checked)

  setManufacturingDetailsOpen(Boolean(manufacturingCategory?.checked || hasSelectedManufacturingDetail()))
  manufacturingToggle?.addEventListener("click", () => {
    setManufacturingDetailsOpen(manufacturingDetails.hidden)
  })
  manufacturingCategory?.addEventListener("change", () => {
    setManufacturingDetailsOpen(manufacturingCategory.checked || hasSelectedManufacturingDetail())
  })
  manufacturingDetailInputs.forEach((input) => {
    input.addEventListener("change", () => {
      if (input.checked && manufacturingCategory) manufacturingCategory.checked = true
      setManufacturingDetailsOpen(Boolean(manufacturingCategory?.checked || hasSelectedManufacturingDetail()))
    })
  })

  const locationData = document.querySelector("#jobs-new-location-data")
  const prefectureSelect = document.querySelector("[data-prefecture-select]")
  const municipalitySelect = document.querySelector("[data-municipality-select]")

  if (locationData && prefectureSelect && municipalitySelect) {
    const municipalities = JSON.parse(locationData.textContent)
    const selectedMunicipalityId = municipalitySelect.dataset.selectedValue

    const updateMunicipalities = () => {
      const prefectureId = prefectureSelect.value
      municipalitySelect.replaceChildren(new Option("すべての市区町村", ""))

      municipalities
        .filter((municipality) => String(municipality.prefecture_id) === prefectureId)
        .forEach((municipality) => {
          const option = new Option(
            `${municipality.name}【${municipality.count}】`,
            municipality.id
          )
          option.selected = String(municipality.id) === selectedMunicipalityId
          municipalitySelect.add(option)
        })

      municipalitySelect.disabled = !prefectureId
    }

    prefectureSelect.addEventListener("change", () => {
      municipalitySelect.dataset.selectedValue = ""
      updateMunicipalities()
    })
    updateMunicipalities()
  }

  const sortSelect = document.querySelector("[data-sort-select]")
  sortSelect?.addEventListener("change", () => {
    const url = new URL(window.location.href)
    if (sortSelect.value) {
      url.searchParams.set("sort", sortSelect.value)
    } else {
      url.searchParams.delete("sort")
    }
    url.searchParams.delete("page")
    window.location.assign(url.toString())
  })

  const drawer = document.querySelector("#job-drawer")
  if (!drawer) return

  const frame = drawer.querySelector(".job-drawer__frame")
  const openTabLink = drawer.querySelector("[data-drawer-open-tab]")
  const applicationLink = drawer.querySelector("[data-drawer-apply]")

  document.querySelectorAll("[data-open-job-drawer]").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault()
      frame.src = link.dataset.drawerUrl
      openTabLink.href = link.href
      applicationLink.href = link.dataset.applicationUrl
      drawer.showModal()
      document.body.classList.add("drawer-open")
    })
  })

  drawer.querySelector("[data-close-job-drawer]")?.addEventListener("click", () => drawer.close())
  drawer.addEventListener("click", (event) => {
    if (event.target === drawer) drawer.close()
  })
  drawer.addEventListener("close", () => {
    document.body.classList.remove("drawer-open")
    frame.removeAttribute("src")
  })
})
